import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { GraphQLSubscribe } from '../utils/methods/graphql.subscribe';

@Injectable()
export class UpdateTerminalStatusSubscription extends GraphQLSubscribe {
	override command: DocumentNode = gql`
		subscription onUpdateTerminalStatus {
			onUpdateTerminalStatus {
				accountId
				batchId
				orderNumber
				position
				terminalId
				status
				itemOperations {
					id
					alias
					terminalId
					batchId
					items
				}
			}
		}
	`;
}
